import { Flex, Form } from 'antd';
import TextField from '../form/text-field/text-field';
import { Button } from '../button/button';
import styles from './reset-password-form.module.scss';
import Icon from '@ant-design/icons';
import CheckCircle from '@/assets/icons/check-circle.svg?react';
import { useState } from 'react';
import clsx from 'clsx';
import { getPasswordRequirements } from './reset-password-form.utils';

export type ResetPasswordFieldType = {
  password: string;
  password_confirmation: string;
};

interface ResetPasswordFormProps {
  onSubmit: (values: ResetPasswordFieldType) => void;
  error?: string;
  isLoading?: boolean;
}

export function ResetPasswordForm({ onSubmit, error, isLoading }: ResetPasswordFormProps) {
  const [newPassword, setNewPassword] = useState({ password: '', password_confirmation: '' });

  const enableButton = getPasswordRequirements(newPassword.password).every(
    ({ fulfilled }) => fulfilled
  );

  return (
    <Flex vertical gap={24} className={styles.container}>
      <h3 className={styles.title}>Reset your password</h3>
      <Form
        onFinish={onSubmit}
        autoComplete="off"
        className={styles.formContainer}
        requiredMark="optional"
        layout="vertical"
      >
        <Form.Item<ResetPasswordFieldType>
          label="New password"
          name="password"
          htmlFor="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <TextField
            value={newPassword.password}
            onChange={(event) => setNewPassword({ ...newPassword, password: event.target.value })}
            type="password"
          />
        </Form.Item>
        <Form.Item<ResetPasswordFieldType>
          label="Confirm password"
          name="password_confirmation"
          htmlFor="password_confirmation"
          rules={[{ required: true, message: 'Please input your password confirmation!' }]}
        >
          <TextField
            value={newPassword.password_confirmation}
            disabled={!enableButton}
            onChange={(event) =>
              setNewPassword({ ...newPassword, password_confirmation: event.target.value })
            }
            type="password"
          />
        </Form.Item>
        <Flex vertical gap={8} className={styles.checksContainer}>
          {getPasswordRequirements(newPassword.password).map(({ text, fulfilled }) => (
            <Flex gap={8} align="center" key={text}>
              <Icon
                component={() => (
                  <CheckCircle
                    width={16}
                    height={16}
                    stroke={clsx(fulfilled ? styles.greenIconColor : styles.iconColor)}
                  />
                )}
              />
              <p>{text}</p>
            </Flex>
          ))}
        </Flex>
        <Form.Item className={styles.submitButton}>
          <Button
            disabled={!enableButton || newPassword.password !== newPassword.password_confirmation}
            size="large"
            type="primary"
            htmlType="submit"
            loading={isLoading}
            block
          >
            Reset Password
          </Button>
        </Form.Item>
        {error && <p className={styles.error}>{error}</p>}
      </Form>
    </Flex>
  );
}
